<template>
  <tr>
    <th class="py-4" style="width: 30%"></th>
    <DayCell
      v-for="day in dates"
      :key="day"
      :day="day"
      :order="getOrderByDay(day)"
      style="width: 10%" />
  </tr>
</template>

<script>
import isSameDay from 'date-fns/isSameDay'
import parseISO from 'date-fns/parseISO'

import DayCell from './DayCell'

export default {
  name: 'DataHeadRow',
  components: { DayCell },
  props: {
    dates: {
      type: Array,
      required: true
    },
    orders: {
      type: Array,
      required: false
    }
  },

  methods: {
    getOrderByDay(day) {
      return this.orders ? this.orders.find(order => isSameDay(parseISO(order.date), day)) : undefined
    }
  }
}
</script>
